import React from 'react';
import './libro.css';
import { useTranslation } from 'react-i18next';
import LA_vector from '../../../../assets/imgs/home_cinco/LA_vector.png'
import libro_blanco from '../../../../assets/img/libros 1.png'

const Libro = () => {
    const [t, i18n] = useTranslation("home");
    const liga_lang1='/'+i18n.language+"/LibroSociedades";

        return (
            <div class='LV_contenedor'>
                <div class='LV_contenedor_escritorio'>
                    <div class="LV_imgLibro">
                        <img src={libro_blanco} alt="Imagen libro" class="LV_libro" />
                    </div>
                    <div class="LV_txt">
                        <h1>
                        {(t('slider.ideas-green'))} <br/>
                            <span>{(t('slider.society'))}</span>
                        </h1>
                        <img src={LA_vector} alt="Imagen Vector" class="LB_linea" />
                        <p dangerouslySetInnerHTML={{__html: (t('slider.second'))}}>
                        </p>
                        <a href={liga_lang1} class="H5_LB_txt-button">{(t('slider.more'))}</a>
                    </div>
                </div>

                <div class='LV_contenedor_movil'>
                    <div class="LV_movil_titulo">
                        <h2>{(t('slider.details'))} <br/>
                            <span>{(t('slider.second-book'))}</span></h2>
                    </div>
                    <div class="LV_movil_txt">
                        <p><span>{(t('slider.ideas-big'))}</span> {(t('slider.change-society'))}<br/>
                        {(t('slider.world'))}
                        </p>
                    </div>
                    <div class="LV_movil_img">
                        <img src={libro_blanco} />
                        <a href={liga_lang1} class="LV_movil_img-button">{(t('slider.more'))}</a>
                    </div>
                </div>
            </div>
        );
    }
export default Libro